import { BookCheck, ReceiptText, Store, Wallet, type LucideIcon } from "lucide-react";
import { Icon } from "../../ui";
import { PageWidth } from "../StoreShell";

// Only what the shop does today (KALI-31): no delivery promise, no returns window, no card payments.
const FACTS: [LucideIcon, string, string][] = [
  [BookCheck, "Checked against the book", "Every number here is checked against the manufacturer's book"],
  [Store, "Free pickup at our counter", "Or delivered anywhere in the Philippines"],
  [Wallet, "Bank transfer or cash on delivery", "Checkout tells you if cash on delivery suits your order"],
  [ReceiptText, "Prices include tax", "Delivery is quoted separately"],
];

/** Four true facts under the search band (desktop kit TrustStrip). */
export function TrustStrip() {
  return (
    <div className="border-b border-border-subtle bg-surface-card">
      <PageWidth className="grid grid-cols-2 gap-x-5 gap-y-4 py-4 lg:grid-cols-4 lg:gap-6">
        {FACTS.map(([icon, title, detail]) => (
          <div key={title} className="flex items-start gap-3">
            <Icon icon={icon} size={22} className="mt-0.5 flex-none text-green-700" />
            <span>
              <span className="block type-h4 [font-size:var(--text-sm)] text-text-strong">{title}</span>
              <span className="block type-small text-text-muted">{detail}</span>
            </span>
          </div>
        ))}
      </PageWidth>
    </div>
  );
}
